/**
 * 创建副本：与 Ctrl/Cmd+D 同能力，挂到图层快捷条。
 */
import { getLocaleStore } from '@/i18n';
import type { IShortcutMenuItemRenderArgs } from '@/plugins/shortcut-menu/type';
import { ShortcutToolbarIconItem } from '@/plugins/shortcut-menu/views/shortcut-toolbar-widgets';
import { LayerType } from '@/version-types';
import { LayerHotkeyType } from '../../../../type';

export const layerCloneShortcutItem = ({ framework, layer }: IShortcutMenuItemRenderArgs) => {
    const { $t } = getLocaleStore();
    const isWatermark = layer.layerType === LayerType.WATERMARK;
    if (isWatermark) return null;

    return (
        <ShortcutToolbarIconItem
            name="DuplicateBold"
            title={$t((v) => v.baseLayer.shortcutOperate.copy)}
            onClick={(e) => {
                e.stopPropagation();
                framework.service.hotkey.__emit(LayerHotkeyType.CLONE, { from: 'shortcut-menu' });
                // framework.service.registration
                //     .getInstance<ShortcutMenu>('ShortcutMenu')
                //     .emitClick(SHORTCUT_FUNC_MAP.createCopy);
            }}
        />
    );
};
